import { render, staticRenderFns } from "./CmgLeaderboardTile.vue?vue&type=template&id=619ff6b6&scoped=true&lang=pug"
import script from "./cmg-leaderboard-tile.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-tile.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardTile.vue?vue&type=style&index=0&id=619ff6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619ff6b6",
  null
  
)

export default component.exports